export default {
	title: "Lorem ipsum",
	descriptionShort: "",
	description: "",
	cover: "",
	metaKeywords: "lorem,ipsum"
}
